[
  {
    "id": "MET-OPP-L3-002",
    "module": "Metriek",
    "difficulty": 201,
    "question": "De oppervlakte van een vierkant is 36 $cm^2$. Hoe lang is één zijde?",
    "options": [
      "6 cm",
      "9 cm",
      "18 cm",
      "4 cm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-VIERKANT",
    "explanation": "Bij een vierkant zijn alle zijden even lang. Welk getal × zichzelf = 36? Dat is 6, want 6 × 6 = 36.",
    "distractorExplanations": {
      "1": "Je deed 36 : 4. Maar dat is voor eromheen, niet voor hoeveel erin past!",
      "2": "Je deed 36 : 2. Maar zoek een getal dat × zichzelf = 36.",
      "3": "Te klein! Probeer: 4 × 4 = 16. Dat is geen 36."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 6,
        "height": 6,
        "mode": "area",
        "label": "Vierkant: 6 × 6 = 36 cm²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L2-002",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Hoeveel decimeter (dm) is 4,5 kilometer?",
    "options": [
      "450 dm",
      "4.500 dm",
      "45.000 dm",
      "450.000 dm"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-OMREKENEN",
    "explanation": "Van km naar dm zijn het 4 trapjes omlaag. Dus: 4,5 × 10.000 = 45.000 dm.",
    "distractorExplanations": {
      "0": "Te vroeg gestopt! Van km naar dm zijn het 4 stapjes.",
      "1": "Je stopte bij meter. Nog één stapje verder naar dm!",
      "3": "Eén stapje te ver! Je kwam bij cm uit."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "dm",
        "value": 4.5,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L3-001",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een doos is 5 dm lang, 4 dm breed en 3 dm hoog. Wat is de inhoud in liters?",
    "options": [
      "12 liter",
      "60 liter",
      "120 liter",
      "20 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-DOOS",
    "explanation": "Inhoud = lengte × breedte × hoogte: 5 × 4 × 3 = 60. En 1 dm³ = 1 liter.",
    "distractorExplanations": {
      "0": "Je deed 5 + 4 + 3. Maar bij inhoud moet je keer elkaar doen!",
      "2": "Je rekende verkeerd: 5 × 4 × 3 = 60, niet 120.",
      "3": "Je deed alleen de bodem (5 × 4). Maar je moet ook keer de hoogte!"
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Inhoud Berekenen",
        "content": "Inhoud = lengte × breedte × hoogte. 1 dm³ = 1 liter.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L3-001",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een rechthoekig voetbalveld heeft een omtrek van 300 meter. De lengte is 100 meter. Wat is de breedte?",
    "options": [
      "200 meter",
      "50 meter",
      "100 meter",
      "150 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-VOETBALVELD",
    "explanation": "De twee lange kanten samen zijn 200 m. Dan blijft 100 m over voor de twee korte kanten. 100 : 2 = 50 m.",
    "distractorExplanations": {
      "0": "Dit is voor de twee korte kanten samen. Deel het nog door 2!",
      "2": "Dan zou het vierkant zijn. Check: 100 + 100 + 100 + 100 = 400. Dat is te veel!",
      "3": "Je deed 300 : 2. Maar haal eerst de twee lange kanten eraf!"
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Omtrek Terugrekenen",
        "content": "Trek eerst 2 × lengte af van de omtrek en deel daarna door 2.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L3-001",
    "module": "Metriek",
    "difficulty": 201,
    "question": "De oppervlakte van een vierkant schilderij is 81 $cm^2$. Hoe lang is één zijkant?",
    "options": [
      "9 cm",
      "20,25 cm",
      "40,5 cm",
      "81 cm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-SCHILDERIJ",
    "explanation": "Bij een vierkant zijn alle kanten even lang. 9 × 9 = 81, dus de zijkant is 9 cm.",
    "distractorExplanations": {
      "1": "Je deed 81 : 4. Dat doe je bij omtrek, niet bij oppervlakte.",
      "2": "Je deed 81 : 2. Maar zoek een getal dat × zichzelf = 81.",
      "3": "Dit is hoeveel erin past, niet de lengte van één kant!"
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 9,
        "height": 9,
        "mode": "area",
        "label": "Vierkant: 9 × 9 = 81 cm²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L2-002",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een balk is 2 meter lang, 50 centimeter breed en 20 centimeter hoog. Wat is de inhoud in kubieke decimeters ($dm^3$)?",
    "options": [
      "20 $dm^3$",
      "200 $dm^3$",
      "100 $dm^3$",
      "2.000 $dm^3$"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BALK",
    "explanation": "Zet eerst alles om naar dm: 2 m = 20 dm, 50 cm = 5 dm, 20 cm = 2 dm. Inhoud = 20 × 5 × 2 = 200 dm³.",
    "distractorExplanations": {
      "0": "Je telde de getallen op. Maar je moet lengte × breedte × hoogte doen.",
      "2": "Je maakte een rekenfout: 20 × 5 × 2 = 200.",
      "3": "Je rekende met cm of m. Zet eerst alles om naar dm."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Inhoud in dm³",
        "content": "Stap 1: Zet alles om naar dm. Stap 2: Reken: 20 × 5 × 2 = 200 dm³.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L3-001",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een pad is 120 meter lang. Elke tegel is 40 centimeter lang. Hoeveel tegels zijn nodig?",
    "options": [
      "30",
      "120",
      "300",
      "3.000"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-PAD",
    "explanation": "Maak de maten gelijk: 120 meter = 12.000 cm. Dan delen: 12.000 : 40 = 300 tegels.",
    "distractorExplanations": {
      "0": "Je deed 120 : 4. Maar 120 is meters en 40 is centimeters!",
      "1": "Je deed 1.200 : 40. Maar 120 meter = 12.000 cm!",
      "3": "Een nul te veel. Check: 12.000 : 40 = 300."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Gelijke Maten",
        "content": "Reken nooit met meters en cm door elkaar! Maak er eerst allemaal cm van.",
        "icon": "alert"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L3-003",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een aquarium is 50 cm lang, 30 cm breed en 40 cm hoog. Hoeveel liter water past erin?",
    "options": [
      "60 liter",
      "120 liter",
      "30 liter",
      "600 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-AQUARIUM",
    "explanation": "Bereken inhoud in cm³: 50 × 30 × 40 = 60.000 cm³. Deel door 1000: 60.000 : 1000 = 60 liter.",
    "distractorExplanations": {
      "1": "Je vergat te delen door 1000 om liter te krijgen.",
      "2": "Je deed alleen 50 × 30. Maar je moet ook keer de hoogte.",
      "3": "Je vergat de omrekening naar liter. 60.000 cm³ is 60 liter."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Inhoud: cm³ naar Liter",
        "content": "Stap 1: Reken inhoud in cm³ (lengte × breedte × hoogte). Stap 2: Deel door 1000.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L4-001",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een sponsorloop is 3,2 km. Hoeveel meter is dat?",
    "options": [
      "320 meter",
      "3.200 meter",
      "32.000 meter",
      "320.000 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-SPONSOR",
    "explanation": "Van km naar m zijn het 3 stappen omlaag. Dus: 3,2 × 1000 = 3.200 meter.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is van km naar hm.",
      "2": "Je deed ×10.000. Dat is één stap te veel.",
      "3": "Je deed ×100.000. Dat is veel te groot."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 3.2,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OPP-L4-002",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een rechthoek heeft een oppervlakte van 96 $m^2$. De breedte is 8 meter. Hoe lang is de rechthoek?",
    "options": [
      "10 meter",
      "12 meter",
      "14 meter",
      "18 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-TERUG",
    "explanation": "Oppervlakte = lengte × breedte. Dus lengte = 96 : 8 = 12 meter.",
    "distractorExplanations": {
      "0": "Je deed 96 - 8. Maar je moet delen om de lengte te vinden.",
      "2": "Je deed 96 : 6. De breedte is 8 meter.",
      "3": "Je deed 96 : 4. Maar dat is te weinig."
    },
    "visualAid": {
      "type": "geo",
      "data": {
        "width": 12,
        "height": 8,
        "mode": "area",
        "label": "Oppervlakte = 96 m²"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L4-002",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Hoeveel meter is 0,035 kilometer?",
    "options": [
      "3,5 meter",
      "35 meter",
      "350 meter",
      "3.500 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-KOMMA",
    "explanation": "Van km naar m zijn het 3 stappen omlaag. Dus: 0,035 × 1000 = 35 meter.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is één stap te weinig.",
      "2": "Je deed ×10.000. Dat is één stap te veel.",
      "3": "Je verplaatste de komma te ver."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 0.035,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L4-002",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een tank bevat 1,2 $m^3$ water. Hoeveel liter is dat?",
    "options": [
      "120 liter",
      "1.200 liter",
      "12.000 liter",
      "120.000 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-TANK-B7",
    "explanation": "1 m³ = 1000 liter. Dus: 1,2 × 1000 = 1.200 liter.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is te weinig. 1 m³ is 1000 liter.",
      "2": "Je zette er een nul te veel bij. 1,2 × 1000 = 1.200.",
      "3": "Je deed ×100.000. Dat is veel te groot."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "m3",
        "to": "l",
        "value": 1.2,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L4-003",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een bak is 1,5 m lang, 40 cm breed en 30 cm hoog. Hoeveel liter past erin?",
    "options": [
      "18 liter",
      "180 liter",
      "1.800 liter",
      "18.000 liter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BAK-B7",
    "explanation": "Zet om naar dm: 1,5 m = 15 dm, 40 cm = 4 dm, 30 cm = 3 dm. Inhoud = 15 × 4 × 3 = 180 dm³ = 180 liter.",
    "distractorExplanations": {
      "0": "Je vergat een factor 10 bij het omrekenen.",
      "2": "Je zette er een nul te veel bij. 180 dm³ is 180 liter.",
      "3": "Je vermenigvuldigde met cm zonder om te rekenen naar dm."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Gemengde maten",
        "content": "Zet eerst alles om naar dm: 1,5 m = 15 dm, 40 cm = 4 dm, 30 cm = 3 dm. Reken dan 15 × 4 × 3.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-OMT-L4-002",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een rechthoek heeft een omtrek van 100 meter. De breedte is 18 meter. Wat is de lengte?",
    "options": [
      "16 meter",
      "23 meter",
      "32 meter",
      "41 meter"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "omtrek",
    "subSkill": "omtrek",
    "familyId": "MET-OMT-TERUG",
    "explanation": "Omtrek = 2 × lengte + 2 × breedte. 2 × 18 = 36. 100 - 36 = 64. Dan 64 : 2 = 32 meter.",
    "distractorExplanations": {
      "0": "Je deelde 100 door 6 of vergat de breedte weg te halen.",
      "1": "Je vergat nog door 2 te delen. 64 is voor beide lengtes samen.",
      "3": "Je deed 100 - 18. Maar je moet twee breedtes aftrekken."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Omtrek terugrekenen",
        "content": "Trek 2 × breedte af van de omtrek en deel het restant door 2.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L4-001",
    "module": "Metriek",
    "difficulty": 201,
    "question": "Een rugzak weegt 3,6 kg. Er komt een fles van 450 g bij. Hoeveel weegt de rugzak nu in gram?",
    "options": [
      "3.150 g",
      "4.050 g",
      "4.500 g",
      "36.450 g"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-RUGZAK",
    "explanation": "Zet alles om naar gram: 3,6 kg = 3.600 g. Dan optellen: 3.600 + 450 = 4.050 g.",
    "distractorExplanations": {
      "0": "Je trok af in plaats van op te tellen.",
      "2": "Je telde 3,6 en 450 op zonder om te rekenen.",
      "3": "Je zette de komma verkeerd. 3,6 kg is 3.600 g."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Alles in dezelfde eenheid",
        "content": "Zet 3,6 kg om naar gram: 3.600 g. Tel daarna 450 g erbij op.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  }
]